const NotMatch = () => (
  <div>
    <p>Not Found!</p>
  </div>
);

export default NotMatch;
